export default __webpack_public_path__ + "static/media/ico-rating-24.fe0c67b8.svg";